import './assets/css/font.css'
import './assets/css/reset.css'
import './assets/css/main.css'
import VcPage from './components/common/VcPage.vue'

export default {
  install(Vue) {
    Vue.component('vc-page', VcPage);
  }
}
